const WebsiteIcon = () => (
  <svg
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.00014 10.822C1.00014 16.2459 5.39807 20.641 10.8192 20.641C16.2403 20.641 20.6382 16.243 20.6382 10.822C20.6382 5.40086 16.2431 1.00293 10.8192 1.00293C5.39524 1.00293 1.00014 5.40086 1.00014 10.822Z'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
    <path
      d='M5.91926 10.822C5.91926 16.2459 8.11823 20.641 10.8288 20.641C13.5393 20.641 15.7383 16.243 15.7383 10.822C15.7383 5.40086 13.5393 1.00293 10.8288 1.00293C8.11823 1.00293 5.91926 5.40086 5.91926 10.822Z'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
    <path
      d='M3.50142 4.27539C5.29903 5.27877 7.91348 5.9119 10.8219 5.9119C13.7303 5.9119 16.3447 5.27877 18.1423 4.27539'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
    <path
      d='M18.1423 17.368C16.3419 16.3646 13.7303 15.7314 10.8219 15.7314C7.91348 15.7314 5.2962 16.3646 3.49859 17.3708'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
    <path
      d='M20.6406 10.8223H0.999758'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
    <path
      d='M10.8291 1V20.6409'
      stroke='currentColor'
      strokeWidth='0.727731'
      strokeMiterlimit='10' />
  </svg>
)

export default WebsiteIcon